import React from "react";

import { useStateValue } from "../../StateProvider";
import Services from "./serviceCard/Services";

import { Item} from 'semantic-ui-react'

const StepTwo = ({step,setLastSetp}) => {

  const [state, dispatch] = useStateValue();
const { availableServices } = state;
  return (
    <div
      style={{
        padding: "2rem",
        display: "flex",
        height: "100%",
        gap: ".25rem",
      }}
    >
      <Item.Group divided style={{width:'80%',padding: '1rem'}}>
      {availableServices.map((service) => {
        // console.log("serviceID",service)
        return (
          <Services
            key={service._id}
            id={service._id}
            name={service.name}
            location={service.location}
            description={service.description}
            setLastSetp={setLastSetp}
            step={step}
          />
        );
      })}
</Item.Group>
      <div
        style={{
          background: "white",
          width: "20%",
          padding: ".5rem",
          textAlign: "center",
        }}
      >
        Ads goes here
      </div>
    </div>
  );
};

export default StepTwo;
